import type { SxProps, Theme } from '@mui/material';

export const reservationTimeSlot = {
  root: (isSelected: boolean): SxProps<Theme> => ({
    border: '2px solid',
    borderColor: isSelected ? 'secondary.main' : 'primary.main',
    transition: 'all 0.2s',
    backgroundColor: isSelected ? 'secondary.light' : 'transparent',
    '&:hover': { borderColor: 'secondary.main', boxShadow: 3, transform: 'translateY(-2px)' },
  }),
  content: { py: 1, px: 1 } satisfies SxProps,
};
